// =Cookie
// ============================================================================     

/*!
 * jQuery Cookie Plugin v1.4.0
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as anonymous module.
		define(['jquery'], factory);
	} else {
		// Browser globals.
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));

// =COMPONENTS
// ============================================================================

$(document).ready(function()
{
  const defaults = {
    status: {
      active: 'is-active',
    }
  };

  const juksSwitch = {
    init: function() {
      $('[data-juks-switch]').on('click', function(){
        var $this = $(this);
            $parent = $this.parent('[data-juks-parent]');

        if ($parent.hasClass(defaults.status.active)) {
          $parent.removeClass(defaults.status.active);
        } else {
          $parent.addClass(defaults.status.active);
          return false;
        }
      });
    }
  };

  const juksAnnouncementBar = {
    selector: '.pxs-announcement-bar',
    init: function() {
      this.el = document.querySelector(this.selector);
      var currencyDisclosureEl = this.el.querySelector('[data-disclosure-currency]');
      var localeDisclosureEl = this.el.querySelector('[data-disclosure-locale]');

      if (currencyDisclosureEl) {
        this.currencyDisclosure = new window.juksExports.shopify_cross_border_dist_index_es(currencyDisclosureEl);
      }
  
      if (localeDisclosureEl) {
        this.localeDisclosure = new window.juksExports.shopify_cross_border_dist_index_es(localeDisclosureEl);
      }
    }
  };

  const juksCookiesBanner = {
    selector: "#juks-cookies-banner",
    cookieName: 'cookies_alert',
    isOpen: false,
    init: function() {
      this.el = document.querySelector(this.selector);
      this.$el = $(this.el);

      this.cookieValue = $.cookie(this.cookieName);
	  if (!this.cookieValue) this.open();
	  
	  console.log('juks-cookies-banner::init');
	  console.log('cookieValue', this.cookieValue);
    },
    open: function() {
      if (this.isOpen) return;
	  this.isOpen = true;

	  console.log('juks-cookies-banner::open');

      this.$el.on('click.cookieBanner', '.juks-close', $.proxy(this.onClickClose, this));
      this.$el.addClass(defaults.status.active);
    },
    close: function() {
      if (!this.isOpen) return;
      this.isOpen = false;

	  console.log('juks-cookies-banner::close');

      this.$el.off('.cookieBanner');
      this.$el.removeClass(defaults.status.active);
      $.cookie(this.cookieName, 'expires_in_14_days', { expires: 14 });
    },
    onClickClose: function(ev) {
	  console.log('juks-cookies-banner::closeClick');
      this.close();
    },
	};
	
  const juksNewsletterPopup = {
    selector: "#juks-newsletter-popup",
    cookieName: 'newsletter_popup',
    isOpen: false,
    init: function() {
      this.el = document.querySelector(this.selector);
      this.$el = $(this.el);

      this.cookieValue = $.cookie(this.cookieName);
	  	if (!this.cookieValue) this.open();
	  
    },
    open: function() {
      if (this.isOpen) return;
	  	this.isOpen = true;

      this.$el.on('click.newsletterPopup', '.juks-newsletter-popup-close', $.proxy(this.onClickClose, this));
      this.$el.addClass(defaults.status.active);
    },
    close: function() {
      if (!this.isOpen) return;
      this.isOpen = false;

      this.$el.off('.newsletterPopup');
      this.$el.removeClass(defaults.status.active);
      $.cookie(this.cookieName, 'expires_in_14_days', { expires: 14 });
    },
    onClickClose: function(ev) {
		ev.preventDefault();
      this.close();
    },
	};
	
	// Docs: https://swym.it/help/quick-start-guide-with-wishlist-plus-apis-for-shopify/
	const juksSwymWishlist = {
		isInWishlist: null,
		init: function() {
			const self = this;
			var wishlistButton = document.querySelector(".wishlist-btn");
    
			function swymCallbackFn(){    
				if(wishlistButton){
					_swat.fetchWrtEventTypeET(fetchCallbackFn, 4);       
					// fetching all wishlist events
				}
			}
			
			function fetchCallbackFn(products){
				var activeProductId = SwymPageData.empi, 
						activeVariantId = SwymPageData.epi;
				self.isInWishlist = products.find(function(p){
					return p.empi == activeProductId && p.epi == activeVariantId;
				});
				
				if(self.isInWishlist){
					wishlistButton.setAttribute("disabled", true);
				}

				wishlistButton.addEventListener("click", function(e){
					if(SwymPageData){
						SwymPageData.et = 4;	// et 4 stands for wishlist event type

						if(self.isInWishlist){
							_swat.removeFromWishList(SwymPageData, function(e){
								wishlistButton.setAttribute("disabled", false);
							});

							self.isInWishlist = false;
						} else {
							_swat.addToWishList(SwymPageData, function(e){
								wishlistButton.setAttribute("disabled", true);
							});

							self.isInWishlist = true;
						}
					}
				});
			}
			if(!window.SwymCallbacks){
			 window.SwymCallbacks = [];
			}
			window.SwymCallbacks.push(swymCallbackFn);
		}
	};

	const juksAddToCart = {
		elements: {
			addToCart: '.add-to-cart',
			miniCart: '.mini-cart',
		},
		status: {
			visible: 'is-visible',
		},
		init: function() {
			var self = this,
					$addToCart = $(self.elements.addToCart),
					$miniCart = $(self.elements.miniCart);

			$addToCart.on('click', function(){
				window.setTimeout(function(){
					$miniCart.addClass(self.status.visible);
				}, 800);

				openedMiniCart = window.setTimeout(function(){
					$miniCart.removeClass(self.status.visible);
					$miniCart.off('mouseover.miniCartHover');
				}, 8000);

				$miniCart.on('mouseover.miniCartHover', function(){
					$miniCart.removeClass(self.status.visible);
					clearTimeout(openedMiniCart);
				});
			});
			
		},
	};
  
  	const juksCollapseText = {
		elements: {
			text: '.h-juks-collapsible-text',
			summary: '.h-juks-collapsible-summary',
			detail: '.h-juks-collapsible-detail',
			toggle: '.h-juks-collapsible-toggle',
			
		},
		status: {
			collapsed: 'is-collapsed',
		},
		init: function() {
			const self = this;
			$(self.elements.toggle).on('click', function(){

				const $toggle = $(this),
							$text = $toggle.parents(self.elements.text),
							$summary = $text.find(self.elements.summary),
							$detail = $text.find(self.elements.detail);

				console.log('CLICK TOGGLE!');
  			$text.css({
					'height': $summary[0].clientHeight + $toggle.outerHeight() + 'px'
				});

				setTimeout(function() {
					$text.removeClass(self.status.collapsed);
					$text.css({
						'height': $detail[0].clientHeight + $toggle.outerHeight() + 'px'
					});
					setTimeout(function() {
						$text.css({
							'height': null,
						});
					}, 500);
				}, 100);

				return false;
			});
		}
	};

	const juksCookieBot = {
		elements: {
			trigger: '.h-cookie-bot-trigger',
		},
		init: function(){
			const self = this;

			$(self.elements.trigger).on('click', function(){

				javascript:CookieConsent.renew();
				console.log('juksCookieBotTrigger2');
				return false;
			});
		}
	};

	juksSwitch.init();
	juksAnnouncementBar.init();
	juksCookiesBanner.init();
	juksNewsletterPopup.init();
	juksSwymWishlist.init();
	juksAddToCart.init();
	juksCollapseText.init();
	juksCookieBot.init();

});